import React, { useState, useEffect, useRef } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography
} from '@mui/material';

interface OTPModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (otp: number) => void;
  onResend: () => any;
  otpActive?: boolean;
  otpTimer?: number;
}

const OTPModal: React.FC<OTPModalProps> = ({
  open,
  onClose,
  onSubmit,
  onResend,
  otpActive = true,
  otpTimer = 120
}) => {
  const [otp, setOTP] = useState<string[]>(['', '', '', '', '', '']);
  const otpInputs = useRef<(HTMLInputElement | null)[]>([]);

  useEffect(() => {
    if (open) {
      setOTP(['', '', '', '', '', '']); // reset fields when modal opens
      otpInputs.current[0]?.focus();
    }
  }, [open]);

  const handleOTPChange = (index: number, value: string) => {
    const newDigit = value.replace(/\D/g, '').slice(0, 1);
    const newOTP = [...otp];
    newOTP[index] = newDigit;
    setOTP(newOTP);

    if (value === '' && index > 0) otpInputs.current[index - 1]?.focus();
    if (newDigit !== '' && index < 5) otpInputs.current[index + 1]?.focus();
  };

  const handleSubmit = () => {
    const fullOTP = otp.join('');
    onSubmit(+fullOTP);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ textAlign: 'center' }}>Enter OTP</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          {otp.map((digit, index) => (
            <TextField
              key={index}
              size="small"
              inputRef={(input) => (otpInputs.current[index] = input)}
              autoFocus={index === 0}
              required
              type="tel"
              value={digit}
              onChange={(e) => handleOTPChange(index, e.target.value)}
              inputProps={{ maxLength: 1, pattern: '[0-9]*' }}
              style={{ width: '40px', margin: '0 5px' }}
            />
          ))}
        </div>

        {otpActive ? (
          <Typography
            variant="body2"
            color="textSecondary"
            align="center"
            gutterBottom
          >
            OTP expires in {otpTimer}s
          </Typography>
        ) : (
          <Button
            variant="text"
            color="primary"
            onClick={onResend}
            fullWidth
          >
            Resend OTP
          </Button>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">Cancel</Button>
        <Button onClick={handleSubmit} color="primary" disabled={otp.some((d) => d === '') || !otpActive}>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default OTPModal;
